import { getCookie } from './cookies';
import { getUrlParameters } from './url';

export const getAppUtms = () => {
  const params = getUrlParameters();

  let fbclid = params['fbclid'] || undefined;
  const fbclidParsed = fbclid
    ? String(fbclid)
        .replace(/[\[\]\'\"]/g, '')
        .split(',')
    : undefined;
  const isFbclidArray = fbclidParsed && Array.isArray(fbclidParsed);

  if (isFbclidArray) {
    fbclid = fbclidParsed[0];
  }

  const fbc = fbclid
    ? `fb.1.${Math.floor(Date.now() / 1000)}.${fbclid}`
    : undefined;
  const fbp = fbclid
    ? `fb.1.${Math.floor(Date.now() / 1000)}.${Math.floor(
        Math.random() * (1999999999 - 1000000000 + 1) + 1000000000,
      )}`
    : '';

  return {
    affId: params['affid'],
    custom_ttp: getCookie('_ttp') || undefined,
    custom_fbc: fbc,
    custom_fbp: fbp,
    custom_fbclid: fbclid,
    custom_gclid: params['gclid'],
    custom_ttclid: params['ttclid'],
    custom_wbraid: params['wbraid'],
    custom_gbraid: params['gbraid'],
    custom_order_vlmid: params['vlmid'],
    custom_order_auid: params['utm_auid'],
    custom_ob_click_id: params['ob_click_id'],
    custom_gl: params['_gl'] || params['__gl'],
    custom_taboola_clid: params['taboola_clid'],
    custom_vcid: params['vcid'],
    custom_order_m_ab_var: params['m_ab_var'],
    custom_order_m_ab_name: params['m_ab_name'],
    custom_order_ab_name: params['ab_name'],
    custom_order_ab_var: params['ab_var'],
    ...addCustomParams(),
  };
};

export const getCustomParams = (params: URLSearchParams) => {
  let fbclid = params.get('fbclid') || undefined;
  const fbclidParsed = fbclid
    ? String(fbclid)
        .replace(/[\[\]\'\"]/g, '')
        .split(',')
    : undefined;
  const isFbclidArray = fbclidParsed && Array.isArray(fbclidParsed);

  if (isFbclidArray) {
    fbclid = fbclidParsed[0];
  }

  const fbc = fbclid
    ? `fb.1.${Math.floor(Date.now() / 1000)}.${fbclid}`
    : undefined;
  const fbp = fbclid
    ? `fb.1.${Math.floor(Date.now() / 1000)}.${Math.floor(
        Math.random() * (1999999999 - 1000000000 + 1) + 1000000000,
      )}`
    : '';

  return {
    affId: params.get('affid') || undefined,
    custom_ttp: getCookie('_ttp') || undefined,
    custom_fbc: fbc,
    custom_fbp: fbp,
    custom_fbclid: fbclid,
    custom_gclid: params.get('gclid') || '',
    custom_ttclid: params.get('ttclid') || '',
    custom_wbraid: params.get('wbraid') || '',
    custom_gbraid: params.get('gbraid') || '',
    custom_order_vlmid: params.get('vlmid') || '',
    custom_order_auid: params.get('utm_auid') || '',
    custom_ob_click_id: params.get('ob_click_id') || '',
    custom_gl: params.get('_gl') || params.get('__gl') || '',
    custom_taboola_clid: params.get('taboola_clid') || '',
    custom_vcid: params.get('vcid') || '',
    ...addCustomParams(),
  };
};

export const getCustomCookieParams = () => {
  const urlParamsCookie = getCookie('urlParams');
  const gaParameter = getCookie('_ga');
  const urlParams = urlParamsCookie ? JSON.parse(urlParamsCookie) : {};

  const getParam = (key: string) => urlParams[key] || undefined;

  let fbclid = getParam('fbclid');
  const fbclidParsed = fbclid
    ? String(fbclid)
        .replace(/[\[\]\'\"]/g, '')
        .split(',')
    : undefined;
  const isFbclidArray = fbclidParsed && Array.isArray(fbclidParsed);

  if (isFbclidArray) {
    fbclid = fbclidParsed[0];
  }

  const fbc = fbclid
    ? `fb.1.${Math.floor(Date.now() / 1000)}.${fbclid}`
    : undefined;
  const fbp = fbclid
    ? `fb.1.${Math.floor(Date.now() / 1000)}.${Math.floor(
        Math.random() * (1999999999 - 1000000000 + 1) + 1000000000,
      )}`
    : '';

  return {
    custom_order_affId: getParam('affid'),
    custom_order_ttp: getCookie('_ttp') || undefined,
    custom_order_fbc: fbc,
    custom_order_fbp: fbp,
    custom_order_fbclid: fbclid,
    custom_order_gclid: getParam('gclid') || '',
    custom_order_ga: gaParameter || '',
    custom_order_ttclid: getParam('ttclid') || '',
    custom_order_wbraid: getParam('wbraid') || '',
    custom_order_gbraid: getParam('gbraid') || '',
    custom_order_vlmid: getParam('vlmid') || '',
    custom_order_auid: getParam('utm_auid') || '',
    custom_order_ob_click_id: getParam('ob_click_id') || '',
    custom_order_gl: getParam('_gl') || getParam('__gl') || '',
    custom_order_taboola_clid: getParam('taboola_clid') || '',
    custom_order_http_referer: getParam('http_referer') || '',
    custom_order_vcid: getParam('vcid') || '',
    ...addCustomParams(),
  };
};

export const addCustomParams = () => {
  const params = getUrlParameters();
  const customParams: any = {};

  params['ad_id'] && (customParams.custom_order_ad_id = params['ad_id']);
  params['campaign_id'] &&
    (customParams.custom_order_campaign_id = params['campaign_id']);
  params['platform'] &&
    (customParams.custom_order_platform = params['platform']);
  params['publisher_name'] &&
    (customParams.custom_order_publisher_name = params['publisher_name']);
  params['site_id'] && (customParams.custom_order_site_id = params['site_id']);
  params['creative_id'] &&
    (customParams.custom_order_creative_id = params['creative_id']);
  params['creative_name'] &&
    (customParams.custom_order_creative_name = params['creative_name']);
  params['flight_id'] &&
    (customParams.custom_order_flight_id = params['flight_id']);
  params['flight_name'] &&
    (customParams.custom_order_flight_name = params['flight_name']);

  // MediaGo
  params['mg_tracking_id'] &&
    (customParams.custom_order_mg_tracking_id = params['mg_tracking_id']);

  // Newsbreak
  params['nb_tracking_id'] &&
    (customParams.custom_order_nb_tracking_id = params['nb_tracking_id']);
  params['newsbreak_cid'] &&
    (customParams.custom_order_newsbreak_cid = params['newsbreak_cid']);

  // Taboola
  params['tb_click_id'] &&
    (customParams.custom_order_tb_click_id = params['tb_click_id']);

  return customParams;
};
